<template>
  <v-sheet :color="color">
    <v-container
      class="py-10 py-md-13 py-lg-16 px-md-7 position-relative item"
      :class="{ 'item-bg': justify === 'start' }"
      :fluid="mdOnly"
    >
      <v-row align="center" justify="center" class="mx-md-n7">
        <v-col
          cols="12"
          md="7"
          :order="justify === 'start' ? 0 : 12"
          class="px-md-7"
        >
          <div
            class="
              primary--text
              text-h5 text-md-h4 text-center text-md-left
              font-weight-bold
            "
          >
            {{ title }}
          </div>

          <img
            v-if="mobile && img && !video"
            class="d-block rounded mx-auto mt-6 item-img"
            :src="files + img"
            :alt="title"
            width="80%"
          />

          <div
            v-if="mobile && video"
            class="mt-6 position-relative cursor-pointer item-video-content"
          >
            <transition name="fade">
              <div
                v-if="!isPlaying"
                class="d-flex align-center justify-center item-video-mask"
              >
                <v-icon color="#ffffff" :size="mobile ? '40px' : '50px'">
                  fa-play-circle
                </v-icon>
              </div>
            </transition>

            <video
              @click="(e) => playVideo(e)"
              class="d-block rounded mx-auto item-video"
              :src="files + video"
              :controls="isPlaying"
              width="320px"
            ></video>
          </div>

          <div
            v-if="text"
            class="grey--text text--darken-2 text-body-1 mt-4 ck-content"
            v-html="text"
          ></div>

          <div v-if="topics.length" class="mt-4 grid-list">
            <template v-for="(topic, keyTopics) in topics">
              <TopicTemplate :key="keyTopics" :item="topic" />
            </template>
          </div>
        </v-col>

        <v-col
          v-if="!mobile && (img || video)"
          cols="12"
          md="4"
          :order="justify === 'start' ? 12 : 0"
          class="px-md-7"
        >
          <img
            v-if="img && !video"
            class="d-block rounded item-img"
            :src="files + img"
            :alt="title"
            width="100%"
          />

          <div
            v-if="video"
            class="
              overflow-hidden
              rounded
              position-relative
              cursor-pointer
              item-video-content
            "
          >
            <transition name="fade">
              <div
                v-if="!isPlaying"
                class="d-flex align-center justify-center item-video-mask"
              >
                <v-icon color="#ffffff" :size="mobile ? '40px' : '50px'">
                  fa-play-circle
                </v-icon>
              </div>
            </transition>

            <video
              @click="(e) => playVideo(e)"
              class="d-block item-video"
              :src="files + video"
              :controls="isPlaying"
              width="100%"
            ></video>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
import TopicTemplate from "../templates/TopicTemplate.vue";

export default {
  props: {
    img: {
      type: String,
      default: "",
    },
    video: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      default: "",
    },
    topics: {
      type: Array,
      default: () => [],
    },
    color: {
      type: String,
      default: "#ffffff",
    },
    justify: {
      type: String,
      default: "start",
      validator: (v) => ["start", "end"].includes(v),
    },
  },
  data: () => ({
    isPlaying: false,
  }),
  computed: {
    mdOnly() {
      return this.$vuetify.breakpoint.mdOnly;
    },
    mobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    playVideo(e) {
      const video = e.target;

      if (video.paused) {
        video.play();

        setTimeout(() => {
          this.isPlaying = true;
        }, 100);
      } else {
        video.pause();
        this.isPlaying = false;
      }
    },
  },
  components: {
    TopicTemplate,
  },
};
</script>

<style lang="scss" scoped>
.item {
  &-bg {
    &:before {
      background-image: url(../../assets/img/points-bg.svg),
        url(../../assets/img/points-bg.svg);
      background-position: top left, bottom left;
      background-repeat: no-repeat;
      background-size: contain;
      content: "";
      height: 375px;
      left: 100%;
      margin-top: -190px;
      pointer-events: none;
      position: absolute;
      top: 50%;
      width: 175px;
    }

    &:after {
      background-image: url(../../assets/img/points-bg.svg);
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
      bottom: -100px;
      content: "";
      height: 200px;
      position: absolute;
      right: 100%;
      width: 200px;
    }
  }

  &-img {
    aspect-ratio: 9 / 16;
    -o-object-fit: cover;
    object-fit: cover;
  }

  .item-video-content {
    .item-video-mask {
      bottom: 0;
      left: 0;
      opacity: 0.7;
      position: absolute;
      right: 0;
      top: 0;
      transition: all 0.1s linear;
    }

    &:hover {
      .item-video-mask {
        opacity: 1;
      }
    }

    .item-video {
      aspect-ratio: 9 / 16;
      -o-object-fit: cover;
      object-fit: cover;

      &:fullscreen {
        -o-object-fit: contain;
        object-fit: contain;
      }
    }
  }

  .grid-list {
    display: grid;
    gap: 8px 15px;
    grid-template-columns: 1fr 1fr;

    @media screen and (max-width: 600px) {
      grid-template-columns: 1fr;
    }
  }
}
</style>
